import { render, staticRenderFns } from "./SettingWard.vue?vue&type=template&id=038d60b0&scoped=true"
import script from "./SettingWard.vue?vue&type=script&lang=js"
export * from "./SettingWard.vue?vue&type=script&lang=js"
import style0 from "./SettingWard.vue?vue&type=style&index=0&id=038d60b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d60b0",
  null
  
)

export default component.exports